const KEY = "gs_seen_posts";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };

export function initSeen(posts) {
  if (read()) return;
  const m = {};
  posts.forEach((p) => { m[p.id] = p.comment_count || 0; });
  localStorage.setItem(KEY, JSON.stringify(m));
}

export const isUnread = (p) => {
  const m = read() || {};
  return m[p.id] === undefined || (p.comment_count || 0) > m[p.id];
};

export function markSeen(p) {
  const m = read() || {};
  m[p.id] = p.comment_count || 0;
  localStorage.setItem(KEY, JSON.stringify(m));
}

export const unreadCls = (p) => (isUnread(p) ? "bg-cyan-50 border-cyan-100" : "bg-white border-slate-100");
